import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import usePermissions from 'src/shared/hooks/usePermissions';
import { useSubscriptionData } from 'src/shared/hooks/useSubscriptionData';
import { AiOutlineButton } from '../ai';
import { AgentRequirementControls } from './AgentRequirementControls';
import UpgradeDialog from '../upgradeDialog/upgradeDialog';

/** Plan actions are driven by Subscription's response and do not infer entitlement rules locally. */
export const AgentOperationActionCard: FC<{ busy: boolean; onResume: () => Promise<void>; hasDraft?: boolean }> = ({ busy, onResume, hasDraft = false }) => {
    const { sellerMarketplace, updateSubscription } = useSubscriptionData();
    const { isAllowed } = usePermissions();
    return (
        <AgentRequirementControls disabled={busy}>
            {isAllowed(['SUBSCRIPTION']) ? (
                <UpgradeDialog
                    type='BANNER'
                    marketPlace={sellerMarketplace ?? undefined}
                    redirectUrlFromDashboard={encodeURI(window.location.href)}
                    showCloseButton={false}
                    showUpgradeButtonAsLink
                    message={
                        hasDraft
                            ? T._('Upgrade your plan to continue this configuration. Your draft is saved.', 'Admin')
                            : T._('Upgrade your plan to continue this configuration.', 'Admin')
                    }
                    onUpgradeCompleted={async () => {
                        updateSubscription();
                    }}
                />
            ) : (
                <span>{T._('Ask the account owner or a user with subscription permissions to upgrade the plan.', 'Admin')}</span>
            )}
            <AiOutlineButton
                type='button'
                $size='small'
                disabled={busy}
                onClick={() => {
                    updateSubscription();
                    void onResume();
                }}
            >
                {T._('I upgraded my plan: check again', 'Admin')}
            </AiOutlineButton>
        </AgentRequirementControls>
    );
};
